import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import {LoginRepositoryImpl} from "@/modules/auth/adapter/impl/LoginRepositoryImpl";
import Notify from "@/views/Notify.vue";


const Orders = (resolve: (...modules: any[]) => void) => require(['../views/orders/Orders.vue'], resolve);
const CustomerOrders = (resolve: (...modules: any[]) => void) => require(['../views/customerOrders/CustomerOrders.vue'], resolve);
const About = (resolve: (...modules: any[]) => void) => require(['../views/About.vue'], resolve);
const StartApp = (resolve: (...modules: any[]) => void) => require(['../views/StartApp.vue'], resolve);
Vue.use(VueRouter);

export const routes: Array<RouteConfig> = [
    {
        path: '/bestellungen',
        component: Orders,
        meta: {
            loginRequired: true,
            pageTitle: 'Filialbestellungen',
            pageIcon: 'ordermanager-order',

        }
    },
    {
        path: '/kundenbestellungen',
        component: CustomerOrders,
        meta: {
            loginRequired: true,
            pageTitle: 'Kundenbestellungen',
            pageIcon: 'ordermanager-shopping-bag',

        }
    },
];
/*{
    path: '/waageundkasse',
        component: Scales,
    children:[
    {
        name: 'waageundkasse',
        path: '',
        redirect: '0',
    },
    {
        path: ':masterDataId',
        component: ScalesGrid,
        meta: {
            loginRequired: true,
            pageTitle: 'Waage & Kasse',
            pageIcon: 'fa-cash-register',
        },
    }],
    meta: {
    loginRequired: true,
        pageTitle: 'Waage & Kasse',
        pageIcon: 'fa-cash-register',
},
}*/
const otherRoutes: Array<RouteConfig> = [
    {
        path: '*',
        redirect: '/bestellungen'
    },
    {
        path: '/',
        redirect: '/bestellungen'
    },
    {
        path: '/About',
        name: 'About',
        component: About,
        meta: {
            pageTitle: 'Version',
            pageIcon: 'fa-question',
        },
    },
    {
        path: '/start',
        name: 'start',
        component: StartApp,
        meta: {
            loginRequired: false,
            pageTitle: 'Start',
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    routes: routes.concat(otherRoutes),
});


export default router;
